<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col-10">
      <legend class="usa-legend usa-legend--large">XTOS Comprehensive Shipment Reports</legend>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-3">
      <p>ERRC requires TSPs to submit Shipment Reports within 60 calendar days after the quarter in which a shipment was invoiced. Because of this delay in reporting, shipments displayed for a selected Reporting Calendar Year/Reporting Quarter may not have been booked/delivered during the year/quarter queried.</p>
  </div>
  </div>
  <div class="grid-row padding-bottom-205">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon">Right click on the report and select the
      appropriate options to export.
    </div>
  </div>
  <div>
    <ag-grid-angular
      class="ag-theme-alpine"
      [gridOptions]="xtosShipmentDetailGridOptions"
      [rowData]="xtosComprehensiveReport">
    </ag-grid-angular>
  </div>
</div>
